// Entry point for the build script in your package.json
import("bootstrap");
